import React, { FC } from 'react';
import { type Props } from './types';

const BundleOptionProductSelectorVariationViewNone: FC<Props> = () => <></>;

export default BundleOptionProductSelectorVariationViewNone;
